import { Component, computed, inject, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { InboxAiBadgeComponent } from '../../../inbox-ai/inbox-ai-badge/inbox-ai-badge.component';

type BadgeState = {
  color: 'green' | 'grey';
  name: string;
};

@Component({
  selector: 'inbox-platform-assistant-config-card',
  templateUrl: './platform-assistant-config-card.component.html',
  styleUrls: ['./platform-assistant-config-card.component.scss'],
  imports: [
    MatCardModule,
    GalaxyBadgeModule,
    MatButtonModule,
    MatSlideToggleModule,
    TranslateModule,
    RouterLink,
    InboxAiBadgeComponent,
  ],
})
export class PlatformAssistantConfigCardComponent {
  platformAssistantEnabled = signal<boolean>(false);

  protected readonly badgeState = computed<BadgeState>(() => {
    if (this.platformAssistantEnabled()) {
      return { color: 'green', name: 'INBOX.SETTINGS.ACTIVE' };
    }
    return { color: 'grey', name: 'INBOX.WEBCHAT.SETTINGS.NOT_ACTIVE' };
  });

  private readonly dialog = inject(MatDialog);
  private snackbarService = inject(SnackbarService);
  protected async handleToggleChange(): Promise<void> {
    try {
      //TODO: MEGA-1201 add logic here to enabled/disabled the platform assistant
      this.platformAssistantEnabled.set(!this.platformAssistantEnabled());
      this.snackbarService.openSuccessSnack(
        'INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.PLATFORM_CHAT_STATUS_UPDATED',
      );
    } catch (e) {
      this.snackbarService.openErrorSnack('INBOX.SETTINGS.PLATFORM_ASSISTANT.SETTINGS_CARD.PLATFORM_CHAT_STATUS_ERROR');
    }
  }
}
